import { render, staticRenderFns } from "./AddUserPassword.vue?vue&type=template&id=2a45f9d7"
import script from "./AddUserPassword.vue?vue&type=script&lang=ts"
export * from "./AddUserPassword.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports